import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import H6 from '@base/H6/H6';
import P2 from '@base/P2/P2';
import Link from '@base/Link/Link';
import PropTypes from 'prop-types';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const GoalDiv = styled.div`
  margin-right: ${Spacings.SPACING_3B};
  display: flex;
  align-items: center;
  background: var(--color-base-1);
`;
const DetailsDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const CtgTitle = styled(H6)`
  margin-bottom: ${Spacings.SPACING_1B};
  color: var(--color-text-primary);
`;

const SecDetailsDiv = styled(P2)`
  display: flex;
  color: var(--color-text-secondary);
`;
const GoalImage = styled.img`
  height: ${Spacings.SPACING_10B};
  width: ${Spacings.SPACING_10B};
`;

const anchorStyle = `
  border-radius: ${Spacings.SPACING_2B};
  background-color: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  display: flex;
  padding: ${Spacings.SPACING_7B} ${Spacings.SPACING_7B} ${Spacings.SPACING_7B}
    ${Spacings.SPACING_4B};
  grid-column: span 6;`;

const href =
  '/goal/[goalSlug]/[goalUID]/doubts-and-solutions/[catalogSlug]/[catalogUID]';

const CatalogCard = ({ ctlgItem, className, goalData }) => {
  const { title, ctlgIcon, secText1, secText2, uid: ctlgUID, slug } = ctlgItem;
  const { slug: goalSlug, uid: goalUID } = goalData;
  const as = `/goal/${goalSlug}/${goalUID}/doubts-and-solutions/${slug}/${ctlgUID}`;

  return (
    <Link href={href} as={as} anchorStyle={anchorStyle} className={className}>
      <GoalDiv>
        <GoalImage src={ctlgIcon} />
      </GoalDiv>
      <DetailsDiv>
        <CtgTitle lineClamp={2}>{title}</CtgTitle>
        <SecDetailsDiv>
          {secText1 && secText2
            ? `${`${secText1} `}${Spacings.SPACING_2SPACES}•${
                Spacings.SPACING_2SPACES
              } ${` ${secText2}`}`
            : secText1 || secText2}
        </SecDetailsDiv>
      </DetailsDiv>
    </Link>
  );
};

export default CatalogCard;

CatalogCard.propTypes = {
  ctlgItem: PropTypes.objectOf(PropTypes.any),
  goalData: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string
};
CatalogCard.defaultProps = {
  ctlgItem: {},
  goalData: {},
  className: ''
};
